import SimpleTable from 'components/Tables/SimpleTable';
import React from 'react';
import theme from 'source/theme';

const columns = [
  { title: 'Nome', field: 'name' },
  {
    title: 'Percentagem (%)',
    field: 'percentage',
    render: value => value ?
      parseFloat(value) :
      value
  },
  { title: 'Tipo', field: 'type' },
  { title: 'CAS', field: 'cas' },
  { title: 'EC', field: 'ec' },
  {
    title: 'Perigosa',
    field: 'hazardous',
    render: value =>
      <span style={{ fontWeight: value ? 'bold' : null }}>
        {value ? 'Sim' : 'Não'}
      </span>
  }
];

export default props => {
  const { rowData, data, title } = props;

  const rows = rowData.map(obj => ({
    ...data[obj.substance_id],
    percentage: obj.percentage
  }));

  return (
    <div style={{ padding: 10, backgroundColor: theme.palette.background.light }}>
      <SimpleTable columns={columns} rows={rows} title={title}/>
    </div>
  );
};
